import React from 'react';
import { LinearProgress, Stack, Typography, Box } from '@mui/material';
import ReportSection from './ReportSection';
import EmptyState from './EmptyState';
import { formatMoney, formatNumber, toNumber } from '../utils/formatters';

const OrderServiceProjectRanking = ({ projects = [] }) => {
    const maxAmount = Math.max(...projects.map((item) => toNumber(item.total_amount)), 0);

    return (
        <ReportSection
            title="Ranking por proyecto"
            subtitle="Dónde se concentra la operación y el dinero"
        >
            {projects.length === 0 ? (
                <EmptyState />
            ) : (
                <Stack spacing={1.5}>
                    {projects.slice(0, 8).map((item) => {
                        const progress = maxAmount > 0
                            ? Math.round((toNumber(item.total_amount) / maxAmount) * 100)
                            : 0;

                        return (
                            <Box key={item.project_id}>
                                <Stack direction="row" justifyContent="space-between" spacing={2}>
                                    <Box>
                                        <Typography variant="body2" fontWeight={800}>
                                            {item.project_name}
                                        </Typography>

                                        <Typography variant="caption" color="text.secondary">
                                            {formatNumber(item.total_orders)} OS · {formatNumber(item.ejecutadas)} ejecutadas · {formatNumber(item.no_valorizadas)} sin valorizar
                                        </Typography>
                                    </Box>

                                    <Typography variant="body2" fontWeight={900}>
                                        {formatMoney(item.total_amount)}
                                    </Typography>
                                </Stack>

                                <LinearProgress
                                    variant="determinate"
                                    value={progress}
                                    sx={{ height: 8, borderRadius: 99, mt: 0.7 }}
                                />
                            </Box>
                        );
                    })}
                </Stack>
            )}
        </ReportSection>
    );
};

export default OrderServiceProjectRanking;